import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createCrmSmsSlice = (set, get) => ({
    crmSms: {
        loading: false,
        data: []
    },
    getCrmSms: async (smsId) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ crmSms: { ...state.crmSms, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/crm/message-template/by-reason-id/${smsId}`,
                headers: { token }
            });
            set(state => ({ crmSms: { loading: false, data: resp.data.MessageTemplates } }));
        } catch (error) {
            set(state => ({ crmSms: { loading: false, data: [] } }));
        }
    }
});
